var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('video',{ref:"videoPlayer",staticClass:"video-js",staticStyle:{"width":"100%"}},[(_vm.videosrc)?_c('source',{attrs:{"src":_vm.videosrc,"type":"application/x-mpegURL"}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }